export const painPoints = [
  {
    title: 'You observe a child struggling with unfamiliar motor activities.',
    text: 'The child has difficulty organizing an action, imitating a movement, or learning a new sequence, and you’re trying to determine which observations deserve closer attention.',
  },
  {
    title: 'You spend too much time reviewing theory.',
    text: 'You understand the terminology, but you still find yourself searching through books, notes, and course materials when trying to organize a real case.',
  },
  {
    title: 'You’re unsure how to interpret a motor difficulty.',
    text: 'You recognize a possible praxis-related concern, but you don’t want to assume that one behavior automatically explains what’s happening.',
  },
  {
    title: 'You have information from different sources.',
    text: 'Your session observations, family reports, task descriptions, and contextual details are scattered across different notes.',
  },
  {
    title: 'You suspect something important is missing.',
    text: 'You want to identify which additional observations, contextual details, or task variations could help you understand the situation more clearly.',
  },
  {
    title: 'You struggle to connect motor observations with functional goals.',
    text: 'You need a more organized way to move from observed difficulties toward meaningful participation goals and measurable outcomes.',
  },
  {
    title: 'You want to explain your reasoning more clearly.',
    text: 'You need a structured way to communicate what you observed, what you are considering, and what remains uncertain.',
  },
];
